module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "header"
    }
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../assets/soluti.png"),
      "width": "224",
      "height": "64",
      "alt": "Soluti - Soluções em Negócios Inteligentes",
      "border": "0"
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "fone"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/fone.png"),
      "width": "39",
      "height": "48",
      "alt": "0800 9416601"
    }
  }), _vm._v(" "), _c('span', [_vm._v("CENTRAL DE ATENDIMENTO")]), _vm._v(" "), _c('div', [_vm._v("0800 9416601")])]), _vm._v(" "), _c('ul', {
    attrs: {
      "id": "menu-principal"
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("Inicial")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://www.soluti.com.br/"
    }
  }, [_vm._v("Site da Soluti")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b0db2f30!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 106
// module chunks = 0